/* eslint-disable */

import React from 'react';
import { Typography as AntdTypography } from 'antd';
import './typography.less';
import 'styles/customize-vars.less'
import { Link as RouterLink } from "react-router-dom";

const getTextAlignmentClassName = (property) => `text-align-${property}`

const Title = ({color,className,light,center,bottom,left,right,top, ...titleProps}) => {
  return (
      <AntdTypography.Title className={[
        left && getTextAlignmentClassName('left'),
        right && getTextAlignmentClassName('right'),
        center && getTextAlignmentClassName('center'),
        bottom && getTextAlignmentClassName('bottom'),
        top && getTextAlignmentClassName('top'),
        light && 'color-neutral-5',
        color && `color-${color}`,
        className
      ]} {...titleProps} />
  )
};
const Text = ({color, light, className,center,bottom,left,right,top, ...textProps}) => {
  return <AntdTypography.Text className={[        
    left && getTextAlignmentClassName('left'),
    right && getTextAlignmentClassName('right'),
    center && getTextAlignmentClassName('center'),
    bottom && getTextAlignmentClassName('bottom'),
    top && getTextAlignmentClassName('top'),
    light && 'color-neutral-5',color && `color-${color}`,
    className
  ]} {...textProps} />
};
const Link = (linkProps) => {
  return (
      <RouterLink component={AntdTypography.Link} {...linkProps} />
  );
};

export default {
  Title,Text,Link
}
